import { createI18n } from 'vue-i18n';
import esCL from '@/locales/es-CL.json';
import en from '@/locales/en.json';

export const LOCALE_STORAGE_KEY = 'kosexa_locale';

export function getStoredLocale() {
  try {
    const raw = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (raw === 'en' || raw === 'es-CL') return raw;
  } catch {
    /* noop */
  }
  return null;
}

export function getInitialLocale() {
  const saved = getStoredLocale();
  if (saved) return saved;
  if (typeof navigator !== 'undefined') {
    const nav = String(navigator.language || '').toLowerCase();
    if (nav.startsWith('en')) return 'en';
  }
  return 'es-CL';
}

export function setStoredLocale(code) {
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, code);
  } catch {
    /* noop */
  }
}

export const i18n = createI18n({
  legacy: true,
  locale: getInitialLocale(),
  fallbackLocale: 'es-CL',
  globalInjection: true,
  messages: {
    'es-CL': esCL,
    en,
  },
});

export default i18n;
